import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Skeleton } from './components/Skeleton';
import { Home } from './pages/Home';
import { AllApps } from './pages/AllApps';
import { Profile } from './pages/Profile';

// Admin bundle is lazy-loaded — keeps the initial JS under the §9.1 budget.
const AdminLayout = lazy(() =>
  import('./pages/admin/AdminLayout').then((m) => ({ default: m.AdminLayout })),
);
const AdminApps = lazy(() =>
  import('./pages/admin/AdminApps').then((m) => ({ default: m.AdminApps })),
);
const AdminAnnouncements = lazy(() =>
  import('./pages/admin/AdminAnnouncements').then((m) => ({ default: m.AdminAnnouncements })),
);
const AdminAudit = lazy(() =>
  import('./pages/admin/AdminAudit').then((m) => ({ default: m.AdminAudit })),
);
const AdminUsers = lazy(() =>
  import('./pages/admin/AdminUsers').then((m) => ({ default: m.AdminUsers })),
);
const AdminRequests = lazy(() =>
  import('./pages/admin/AdminRequests').then((m) => ({ default: m.AdminRequests })),
);
const AdminSuggestions = lazy(() =>
  import('./pages/admin/AdminSuggestions').then((m) => ({ default: m.AdminSuggestions })),
);

const AdminFallback = () => (
  <div className="space-y-3">
    <Skeleton className="h-8 w-48" />
    <Skeleton className="h-4 w-72" />
    <Skeleton className="h-10 w-full" />
    <Skeleton className="h-64 w-full" />
  </div>
);

export const App = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route path="/" element={<Home />} />
      <Route path="/apps" element={<AllApps />} />
      <Route path="/profile" element={<Profile />} />
      <Route
        path="/admin"
        element={
          <Suspense fallback={<AdminFallback />}>
            <AdminLayout />
          </Suspense>
        }
      >
        <Route index element={<Navigate to="apps" replace />} />
        <Route
          path="apps"
          element={
            <Suspense fallback={<AdminFallback />}>
              <AdminApps />
            </Suspense>
          }
        />
        <Route
          path="announcements"
          element={
            <Suspense fallback={<AdminFallback />}>
              <AdminAnnouncements />
            </Suspense>
          }
        />
        <Route
          path="audit"
          element={
            <Suspense fallback={<AdminFallback />}>
              <AdminAudit />
            </Suspense>
          }
        />
        <Route
          path="users"
          element={
            <Suspense fallback={<AdminFallback />}>
              <AdminUsers />
            </Suspense>
          }
        />
        <Route
          path="requests"
          element={
            <Suspense fallback={<AdminFallback />}>
              <AdminRequests />
            </Suspense>
          }
        />
        <Route
          path="suggestions"
          element={
            <Suspense fallback={<AdminFallback />}>
              <AdminSuggestions />
            </Suspense>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Routes>
);
